import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_160w_single');
    return (
        <div className="sp-160-single-C">
            <div className="info-box">
                <p className="title">{t('C_title')}</p>
                <p className="desc">{t('C_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/solar-panel-160w-single/3.jpg"
                    srcPad="/responsive/picture/solar-panel-160w-single/3_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-160w-single/3_768.jpg"
                    alt={t('C_title')}
                />
            </div>
        </div>
    );
}
